/// <reference path="../controllers/iinitialize.d.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../messageboxconfig.ts" />
/// <reference path="../controllers/messageboxcontroller.ts" />
/// <reference path="../controllers/iscreencontroller.d.ts" />
/// <reference path="../isessionstorage.d.ts" />

module App.Common.Services {
	'use strict';

	export class NavigationHelperService {

		public static $inject = ['$q', '$state', '$rootScope', '$uibModal', '$sessionStorage', '$injector'];
		constructor(
			private $q: angular.IQService,
			private $state: angular.ui.IStateService,
			private $rootScope: angular.IRootScopeService,
			private $uibModal: angular.ui.bootstrap.IModalService,
			private $sessionStorage: ISessionStorage,
			private $injector: angular.auto.IInjectorService) {
		}

		private onStateChangeOff: Function;

		public currentScreen: Controllers.IScreenController;

		public currentLeftnav: Controllers.ILeftnavController;

		public initializers: Common.Controllers.IInitialize[] = [];

		//DO NOT MAKE PUBLIC. Use ScreenControllerBase.warnOnUnsavedChanges to bypass navigation warnings
		private bypassOnStateChange = false;

		public init() {
			if (this.onStateChangeOff) {
				return;
			}
			this.onStateChangeOff = this.$rootScope.$on('$beforeStateChange', this.onStateChange);

			$(window)
				.on('beforeunload',
				(event: any) => {

					var errorHandler = this.$injector.get('app.common.services.errorHandlerService') as Services.ErrorHandlerService;
					if (!this.currentScreen || !this.currentScreen.hasUnsavedChanges() || errorHandler.errorShown) {
						return undefined;
					}

                    var message = 'Are you sure you want to navigate away from this screen? Any changes made will not be saved.';
					if (typeof event === 'undefined') {
						event = window.event;
					}
					if (event) {
						event.returnValue = message;
					}

					return message;
				});
		}

		public registerInitializer(controller: Common.Controllers.IInitialize) {
			this.initializers.push(controller);
		}

		public unregisterInitializer(controller: Common.Controllers.IInitialize) {
			this.initializers = _.without(this.initializers, controller);
		}

		public runInitializers(): angular.IPromise<any> {
			var initializers = this.initializers.map((initializer) => initializer.initialize());
			if (this.currentLeftnav) {
				initializers.push(this.currentLeftnav.initialize());
			}
			return this.$q.all(initializers);
		}

		public redirectToSignInScreen(returnToCurrentState = true): void {

			if (this.currentScreenIsSignIn()) { return; }

			if (returnToCurrentState) {
				this.$sessionStorage.returnState = this.$state.current.name;
				this.$sessionStorage.returnStateParams = this.$state.params;
			} else {
				delete this.$sessionStorage.returnState;
				delete this.$sessionStorage.returnStateParams;
			}

			this.$state.go('SignIn', null, {
				suppressUnsavedChangesWarning: true
			} as angular.ui.IStateOptions);
		}

		public currentScreenIsSignIn() {
			return this.$state.current.name === 'SignIn';
		}

		public currentScreenIsHome() {
			return this.$state.current.name === 'Home';
		}

		public currentScreenIsDeeds() {
			return this.$state.current.name === 'Deeds';
		}

		public currentScreenIsAdmin() {
			return this.$state.current.name === 'Admin';
		}

		public currentScreenIsTasks() {
			return this.$state.current.name === 'Tasks';
		}

		public currentScreenIsSettings() {
			return this.$state.current.name === 'Settings';
		}

		public currentScreenIsInstructions() {
			return this.$state.current.name.substr(0, 11) === 'Instruction';
		}

		private onStateChange = (event: angular.IAngularEvent,
			toState: angular.ui.IState,
			toParams: Object,
			fromState: angular.ui.IState,
			fromParams: Object,
			options: Common.IStateOptions) => {

			if (this.bypassOnStateChange || !this.currentScreen || !toState
				|| (options && (options.notify === false || options.suppressUnsavedChangesWarning))) {
				return;
			}

			event.preventDefault();

			this.currentScreen.canClose()
				.then((canClose) => {
					if (canClose) {
						this.bypassOnStateChange = true;
						this.currentLeftnav = null;
						this.$state.transitionTo(toState, toParams, options);
						this.bypassOnStateChange = false;
					}
				});
		};

	}

	angular
		.module('app.common.services')
		.service('app.common.services.navigationHelperService', NavigationHelperService);
}